<template>
  <fluke-login-box title="Criar nova senha">
    <div slot="content">
      <div v-if="!resetPasswordToken">
        <div class="check">Token inválido</div>
      </div>
      <div v-if="resetPasswordToken">
        <div class="check" v-if="checkFails">
            Token inválido/expirado.
            <router-link to="/recuperar-senha">Clique aqui para receber um novo link</router-link>
        </div>
        <div class="check" v-if="invalidPassword">Sua senha deve ter pelo menos 6 caracteres</div>
        <div class="check" v-if="passwordsDifferent">As senhas não conferem</div>
        <div class="check" v-if="serverFails">Falha no serviço, tente mais tarde.</div>
        <div class="success" v-if="success">
            Senha atualizada!
            <router-link to="/login">Clique aqui para logar</router-link>
        </div>
        <div class="box-input">
          <label for="password">Nova senha:</label>
          <input
            id="password"
            type="password"
            v-model="password"
            /><br>
        </div>
        <div class="box-input">
          <label for="passwordConfirmation">Confirmação da senha:</label>
          <input
            id="passwordConfirmation"
            type="password"
            v-model="passwordConfirmation"
            v-on:keyup.enter="passwordRecovery" /><br>
        </div>
        <button v-on:click="passwordRecovery">ENVIAR</button>
      </div>
    </div>
    <div slot="links">
      <router-link to="/login">
        Voltar para login
      </router-link>
    </div>
  </fluke-login-box>
</template>

<script>
import axios from 'axios'
import LoginBox from '../components/Main/Content/LoginBox/LoginBox'

export default {
  components: {
    'fluke-login-box': LoginBox,
  },
  data () {
    return {
        password: '',
        passwordConfirmation: '',
        checkFails: false,
        serverFails: false,
        invalidPassword: false,
        passwordsDifferent: false,
        success: false,
        resetPasswordToken: null,
    }
  },
  mounted () {
    this.resetPasswordToken = this.$route.query.t;
  },
  methods: {
    async passwordRecovery()
    {
        this.success = false
        this.checkFails = false
        this.serverFails = false
        this.invalidPassword = false
        this.passwordsDifferent = false

        if (this.password.length < 6) {
            this.invalidPassword = true
            return
        }

        if (this.password !== this.passwordConfirmation) {
            this.passwordsDifferent = true
            return
        }

        var response = '';
        try {
            response = await axios.put(
            this.$myServerAddresses.admin + 'users/change-password',
            {
                reset_password_token: this.resetPasswordToken,
                password: this.password,
            }
            )
            if ( response.data.success == false) {
                this.checkFails = true;
                return;
            }
            this.success = true
        } catch(e) {
            this.serverFails = true;
            console.log(e);
            return;
        }
    }
  }
}
</script>
